import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LincLoginReportService {
  http = inject(HttpClient);

  downloadLoginReport() {
    return this.http.get('buyerlogin/linc/download-login-report', {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
